import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';
import CodeIcon from '@mui/icons-material/Code';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HandshakeIcon from '@mui/icons-material/Handshake';
import PaidIcon from '@mui/icons-material/Paid';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

import {
  COMPANY_VIEW_SCOPES,
  getCompanyAvailability,
} from '../utils/companyAvailability';

const SEARCH_DESTINATION_DEFINITIONS = [
  {
    id: 'keymetrics',
    label: 'Financials',
    Icon: AccountBalanceIcon,
    scope: COMPANY_VIEW_SCOPES.FINANCIALS,
  },
  {
    id: 'jobpostings',
    label: 'Job Postings',
    Icon: WorkOutlineIcon,
    scope: COMPANY_VIEW_SCOPES.JOBS,
  },
  {
    id: 'developer',
    label: 'Adoption Signals',
    Icon: CodeIcon,
    scope: COMPANY_VIEW_SCOPES.DEVELOPER,
  },
  {
    id: 'metrics',
    label: 'Comps',
    Icon: CompareArrowsIcon,
    scope: COMPANY_VIEW_SCOPES.COMPS,
  },
  {
    id: 'guidance',
    label: 'Guidance',
    Icon: FactCheckIcon,
    scope: COMPANY_VIEW_SCOPES.GUIDANCE,
  },
  {
    id: 'partnerhiring',
    label: 'Partner Hiring',
    Icon: HandshakeIcon,
    scope: COMPANY_VIEW_SCOPES.PARTNERS,
  },
];

export const getSearchDestinations = (ticker) => {
  const availability = getCompanyAvailability(ticker);
  const destinations = SEARCH_DESTINATION_DEFINITIONS.filter(
    (destination) => availability.scopes[destination.scope]
  );

  if (availability.scopes[COMPANY_VIEW_SCOPES.ACQUISITION]) {
    destinations.push({
      id: 'acquisition',
      label: 'Transaction',
      Icon: BusinessIcon,
    });
  } else if (availability.scopes[COMPANY_VIEW_SCOPES.PRIVATE]) {
    destinations.push({
      id: 'private',
      label: availability.info.privateCompanyType === 'acquired' ? 'Transaction' : 'Funding',
      Icon: PaidIcon,
    });
  }

  return destinations;
};
